import { Link } from "react-router-dom";

export const transformCohortLog = (event: any, language: string) => {
  const types = event.target?.type?.split(",") || [];

  return {
    items: event.target.items.map((item: any, index: number) => {
      const type = types[index] || event.target?.type;

      switch (type) {
        case "cohort_leader":
        case "program_manager":
        case "users":
          return {
            key: type,
            value: (
              <Link to={`/user/${item.id}`} className="fw-semibold text-decoration-none">
                {item.name || item.id}
              </Link>
            ),
          };

        case "sprint_modules":
          return {
            key: "sprint_modules",
            value: (
              <Link to={`/module/${item.id}`} className="fw-semibold text-decoration-none">
                {item.name || item.id}
              </Link>
            ),
          };

        case "meeting":
          return {
            key: "meeting",
            value: (
              <Link to={`/meeting/${item.id}`} className="fw-semibold text-decoration-none">
                {item.id}
              </Link>
            ),
          };

        default:
          return {
            key: item.name || type,
            value: item.id,
          };
      }
    }),
  };
};
